/**
 * Decodes HTML entities in a string returned by the API (e.g. `&pound;` → `£`)
 * and drops any markup, returning plain text that is safe to assign via
 * `textContent`. Replaces the former `sanitize-html` dependency, which pulled a
 * full server-side HTML parser into the browser bundle to process price strings.
 */
export function decodeHtmlText(html: string | null | undefined): string {
    if (html === null || html === undefined || html === '') {
        return '';
    }
    const doc = new DOMParser().parseFromString(String(html), 'text/html');
    doc.body.querySelectorAll('script, style').forEach(node => node.remove());
    return doc.body.textContent ?? '';
}
